import type { ApiClientMethod } from '@monorepo/api-client';

import { ExternalResponse } from '@/shared/@types/response';

type HttpsClient = <TResponse, TWrapper = ExternalResponse<TResponse>, TParams = object>(opts: {
  url: string;
  apiClient: ApiClientMethod;
  defaultParameters?: Record<string, string>;
}) => (parameter?: { params?: TParams; signal?: AbortSignal }) => Promise<TWrapper>;

export const httpsClient: HttpsClient = (opts) => (parameter) => {
  const request = opts.apiClient;
  const params = parameter?.params || {};
  const signal = parameter?.signal;

  return request(
    opts.url,
    { ...params, ...(opts.defaultParameters && { ...opts.defaultParameters }) },
    signal,
  );
};
